// extracted by mini-css-extract-plugin
export default {"numbers":"subtitleNumbering_numbers__1hsu7","lightNumber":"subtitleNumbering_lightNumber__ycE2T"};